export default {
  titulo: 'Preguntas mas comunes',
  subtitulo: {
    parte1: 'Separamos las preguntas más comunes por temas. Si su pregunta no es respondida,',
    parte2: ' contáctenos.',
  },
};
